import React, { useEffect, useState } from 'react'
import { createCar, fetchCar } from 'services/CarService'
import { Loader } from 'components/Shared/Loader'
import { CarForm, CarSchema, mapCarToFormValues } from 'components/Car/CarForm'
import { SuccessDialog } from 'components/Shared/Dialogs/SuccessDialog'
import { useErrorHandling } from 'context/errorHandling'
import { HTTP_404_ERROR } from 'Constants'
import { useNavigatePrevent } from 'context/navigatePrevent'
import { FormikForm } from 'components/Shared/FormikForm'
import Module from 'constants/customFieldModules'

const emptyCar = {
  brand: '',
  model: '',
  registrationNumber: '',
  trailerRegistrationNumber: '',
  type: '',
  capacity: '',
  loadingSpace: '',
  optionalFeatures: [],
  driverId: '',
  phoneNumber: '',
  carrierId: '',
  filesIds: []
}

function mapCopiedCarToFromValues (car) {
  return ({
    ...mapCarToFormValues(car),
    registrationNumber: ''
  })
}

export function CreateCarForm (props) {
  const [createdDialogOpen, setCreatedDialogOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { handleError } = useErrorHandling()
  const [initialValues, setInitialValues] = useState(null)

  const idOfCopiedCar = props.location.state?.idOfCopiedCar
  const { setNavigationUnlocked } = useNavigatePrevent()

  useEffect(() => {
      if (idOfCopiedCar) {
        fetchCar(idOfCopiedCar).then(response => {
            setInitialValues(mapCopiedCarToFromValues(response))
          }
        ).catch(error =>
          handleError(error, {
            [HTTP_404_ERROR]: 'notifications.error.carNotFound'
          }).then(() => {
            setNavigationUnlocked(h => h.push('/cars'))
          }))
      } else {
        setInitialValues(emptyCar)
      }

    }, [idOfCopiedCar, handleError, setNavigationUnlocked]
  )

  const handleSubmit = (values, onSuccess) => {
    setIsSubmitting(true)
    createCar(values)
      .then(createdCar => onSuccess(createdCar.id)
        .then(() => setCreatedDialogOpen(true))
        .catch(handleError))
      .catch(handleError)
      .finally(() => setIsSubmitting(false))
  }


  return <div>
    <SuccessDialog open={createdDialogOpen}
                   onClose={() => {
                     setCreatedDialogOpen(false)
                     setNavigationUnlocked(h => h.push('/cars'))
                   }} content={'notifications.success.createdCar'}/>
    {initialValues ?
      <FormikForm
        initialValues={initialValues}
        validationSchema={CarSchema}
        validateOnBlur
        enableReinitialize
        onSubmit={handleSubmit}
        customFields={{
          module: Module.Cars
        }}>
        <CarForm
          initialFiles={[]}
          translateTitleLabel={'createCarTitle'}
          isSubmitting={isSubmitting}/>
      </FormikForm> :
      <Loader/>
    }
  </div>
}
